import EnergyConsumptionMenu from './EnergyConsumptionMenu.vue'
export default EnergyConsumptionMenu